import type { FC, ReactNode } from 'react'

import { useRouter } from 'next/router'
import { RefreshCw } from 'lucide-react'
import { EmptyState } from '@/components/blog/empty-state'

interface LoadErrorProps {
    className?: string
}

export const LoadError: FC<LoadErrorProps> = ({ className }): ReactNode => {
    const router = useRouter()

    return (
        <EmptyState
            icon={RefreshCw}
            title='This page is taking a moment'
            description='We could not load these stories just now. Please try again in a few seconds.'
            action={{ label: 'Try again', href: router.asPath, fullReload: true }}
            className={className}
        />
    )
}
